import { intl } from 'lang/intl'
import { subscribeKey } from 'valtio/utils'
import { setFatalError } from '../../FatalError/FatalError'
import { connect, type Room, roomState } from '../webRTCRoom'

let attempts = 0

const checkStateAndAttemptReconnection = (status: Room['status']) => {
  if (status === 'connected') {
    attempts = 0
    return
  }

  if (status === 'disconnected') {
    if (attempts < 3) {
      attempts += 1
      setTimeout(connect, 2000 * attempts)
      // TODO: refactor this https://github.com/23/admin/blob/cde8c930e898c636fb783adcdc05c4a5dc6065aa/packages/room/headless/src/components/monitoring.tsx
    } else {
      setFatalError(
        intl.formatMessage({
          defaultMessage: "You've been disconnected from the webinar.",
        }),
        { reload: 'ask' }
      )
    }
  }
}

const init = () => {
  subscribeKey(roomState, 'status', checkStateAndAttemptReconnection)
}

export { init }
